export const AREAS = {
  all: { name: 'Any', emoji: '🎲', color: 'from-zinc-500 to-zinc-600' },
  face: { name: 'Face', emoji: '😍', color: 'from-amber-500 to-orange-600' },
  mouth: { name: 'Mouth', emoji: '👄', color: 'from-pink-500 to-rose-600' },
  body: { name: 'Body', emoji: '💦', color: 'from-blue-500 to-cyan-600' },
  below: { name: 'Down Below', emoji: '🔥', color: 'from-red-500 to-pink-600' },
  kinky: { name: 'Kinky', emoji: '😈', color: 'from-violet-500 to-purple-600' },
  special: { name: 'Special', emoji: '✨', color: 'from-fuchsia-500 to-pink-600' },
  her: { name: 'For Her', emoji: '🌸', color: 'from-pink-400 to-rose-500' },
} as const;

export type AreaId = keyof typeof AREAS;
